import map from '../museum/museumMap';
import { Coordinate, Move, Position } from '../model';
import { ICarinha } from '../museum/carinhas';
import { Bench } from '../museum/benches';

const offset = {
  left: 66,
  top: -1336,
};

const HORIZONTAL_MOVE = 64;
const VERTICAL_MOVE = 32;

export const getMapPosition = (coord: Coordinate): Position => {
  return {
    left: offset.left + coord.x * HORIZONTAL_MOVE + coord.y * HORIZONTAL_MOVE,
    top: offset.top + coord.x * VERTICAL_MOVE - coord.y * VERTICAL_MOVE,
  };
};

export const getCarinhaPosition = (charCoord: Coordinate, carinha: ICarinha): Position => {
  return {
    left:
      (-carinha.x * HORIZONTAL_MOVE - carinha.y * HORIZONTAL_MOVE) +
      (charCoord.x * HORIZONTAL_MOVE + charCoord.y * HORIZONTAL_MOVE) + 
      HORIZONTAL_MOVE - (carinha.dir === 'right' ? HORIZONTAL_MOVE / 2 : 0) 
      - (carinha.isOnFloor ? HORIZONTAL_MOVE / 2 : 0),
    top:
      (-carinha.x * VERTICAL_MOVE + carinha.y * VERTICAL_MOVE) +
      (charCoord.x * VERTICAL_MOVE - charCoord.y * VERTICAL_MOVE)
      - VERTICAL_MOVE - (carinha.isOnFloor ? 0 : VERTICAL_MOVE),
  };
};

export const getBenchPosition = (charCoord: Coordinate, bench: Bench): Position => {
  return {
    left:
      (-bench.x * HORIZONTAL_MOVE - bench.y * HORIZONTAL_MOVE) +
      (charCoord.x * HORIZONTAL_MOVE + charCoord.y * HORIZONTAL_MOVE),
    top:
      (-bench.x * VERTICAL_MOVE + bench.y * VERTICAL_MOVE) +
      (charCoord.x * VERTICAL_MOVE - charCoord.y * VERTICAL_MOVE) - 15,
  };
};

export const isBehindWall = (coord: Coordinate): boolean => { 
  try {
    const bottom = map[coord.y + 1][coord.x];
    const left = map[coord.y][coord.x - 1];
    const bottomLeft = map[coord.y + 1][coord.x - 1];
    const checks = [bottom, left, bottomLeft];
  
    return checks.some(c => c === 1 || c === 2);
  } catch {
    return false;
  }
};

export const isSeated = (coord: Coordinate): boolean => {
  try {
    return map[coord.y][coord.x] === 3;
    } catch {
    return false;
  }
};

export const getDirectionClass = (coord: Coordinate, dir: Move): string => {
  if (!isSeated(coord)) return dir;

  switch (dir) {
    case 'up': return 'sit-down';
    case 'down': return 'sit-up';
    case 'right': return 'sit-left';
    case 'left': return 'sit-right';
    default: return dir;
  }
}